/**
 * Indiana Jerky - Quiz Web Component
 * "What's Your Indiana Mode?" interactive quiz section
 */

class QuizSection extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-quiz-option]');
    this.results = this.querySelectorAll('[data-quiz-result]');
    this.resetBtn = this.querySelector('[data-quiz-reset]');

    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => this.selectOption(btn.dataset.quizOption));
    });

    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', () => this.reset());
    }
  }

  selectOption(optionIndex) {
    // Remove active state from all buttons
    this.buttons.forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });

    // Add active state to selected button
    const selectedBtn = this.querySelector(`[data-quiz-option="${optionIndex}"]`);
    if (selectedBtn) {
      selectedBtn.classList.add('is-active');
      selectedBtn.setAttribute('aria-pressed', 'true');
    }

    // Hide all results
    this.results.forEach(r => {
      r.setAttribute('hidden', '');
      r.classList.remove('is-visible');
      r.setAttribute('aria-hidden', 'true');
    });

    // Show matching result with animation
    const result = this.querySelector(`[data-quiz-result="${optionIndex}"]`);
    if (result) {
      result.removeAttribute('hidden');
      result.classList.add('is-visible');
      result.removeAttribute('aria-hidden');

      // Smooth scroll to result on mobile
      if (window.innerWidth < 768) {
        result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // Mark quiz as answered
    this.classList.add('quiz--answered');
  }

  reset() {
    this.buttons.forEach(b => {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });

    this.results.forEach(r => {
      r.setAttribute('hidden', '');
      r.classList.remove('is-visible');
      r.setAttribute('aria-hidden', 'true');
    });

    this.classList.remove('quiz--answered');
  }
}

customElements.define('quiz-section', QuizSection);
